// src/utils/img.js
import { API_BASE } from '../lib/http';

const IMAGE_BASE = (API_BASE && API_BASE.replace(/\/$/, '')) ||
  (typeof process !== 'undefined' && (process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE || '').trim().replace(/\/$/, '')) ||
  'http://localhost:3001';

/** Placeholder used when shop image is missing or fails to load (avoids "?" broken image). */
export const SHOP_PLACEHOLDER = '/images/shop-placeholder.png';

export const img = (u = '') => {
  if (!u || typeof u !== 'string') return '';
  const s = u.trim();
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:')) return s;
  const path = s.replace(/^\/+/, '');
  return path ? `${IMAGE_BASE}/${path}` : '';
};

/** Shop list image src: absolute URL or placeholder so images never show "?". */
export const shopImg = (u) => img(u) || SHOP_PLACEHOLDER;
